<div *ngIf="opened()" class="fixed inset-0 bg-black/40 z-50 lg:hidden" (click)="close.emit()"></div>

<aside class="fixed lg:sticky h-screen lg:h-fit lg:top-[85px] top-0 bg-[#4F4553] rounded-e-lg lg:rounded-lg overflow-hidden z-50"
  [class.left-0]="!isRTL"
  [class.right-0]="isRTL"
  [class.translate-x-0]="opened()"

  [class.-translate-x-full]="!opened() && !isRTL"
  [class.translate-x-full]="!opened() && isRTL"

  [class.lg\:translate-x-0]="true"

  [ngClass]="minimized() ? 'w-[54px]' : '2xl:w-64 w-58'"
>
    <div class="pt-3.5 pb-1.5">

        <div class="flex items-center px-3.5 pb-3" [ngClass]="minimized() ? 'justify-center' : 'justify-between'">
            <img *ngIf="!minimized()" src="shared/text_logo.svg" alt="giftbox" class="h-6 opacity-85">
            <i class="bi hidden lg:flex text-white opacity-70 2xl:text-lg text-base hover:bg-[#F7F7F866] 2xl:w-10 2xl:h-10 w-8 h-8 justify-center items-center 2xl:rounded-2xl rounded-xl cursor-pointer" [ngClass]="minimized() ? 'ms-0 bi-arrows-angle-expand' : 'ms-0.5 bi-arrows-angle-contract'" (click)="toggleMinimize.emit()"></i>
            <i class="bi flex lg:hidden text-white opacity-70 2xl:text-lg text-base hover:bg-[#F7F7F866] 2xl:w-10 2xl:h-10 w-8 h-8 justify-center items-center 2xl:rounded-2xl rounded-xl cursor-pointer" [ngClass]="minimized() ? 'ms-0 bi-arrows-angle-expand' : 'ms-0.5 bi-arrows-angle-contract'" (click)="close.emit()"></i>
        </div>

        <app-navigation-item-group
          *ngFor="let group of sidebarItems"
          [groupTitle]="group?.groupTitle ?? ''"
          [items]="group.items"
          [minimized]="minimized()"
          [classes]="'text-[#F7F7F7]'"
          (click)="group.items[0].link === '/login' && logout()">
        </app-navigation-item-group>

    </div>
</aside>
